export const serviceName = 'contacts';
